import classNames from "classnames"
import React, { forwardRef } from "react"
import type { PropsWithChildren } from "react"

import { storyblokHorizontalGutterClasses } from "@constants/spacing"

type Props = {
  id?: string
  className?: string
} & React.DOMAttributes<HTMLDivElement>

const Section = forwardRef<HTMLElement, PropsWithChildren<Props>>(
  ({ children, id, className, ...props }, ref) => {
    return (
      <section
        ref={ref}
        id={id ? id : undefined}
        className={classNames(storyblokHorizontalGutterClasses, className)}
        {...props}
      >
        {children}
      </section>
    )
  }
)

Section.displayName = "Section"

export default Section
